var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.computedComponent,_vm._g(_vm._b({tag:"component",model:{value:(_vm.computedStep),callback:function ($$v) {_vm.computedStep=$$v},expression:"computedStep"}},'component',_vm.computedProps,false,true),_vm.$listeners),[(!_vm.loading)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }